import { SuperDialog } from "@components:SuperDialog";
import { SVGInternalIcon } from "@components:SVGInternalIcon";
import { Box, TextField } from "@mui/material";
import Typography from "@mui/material/Typography";
import { SuperButton } from "@pages:app/docs/Components/SuperButton";
import { isEmpty } from "lodash";
import { ChangeEvent, useState } from "react";
import { useTranslation } from "react-i18next";

type URLButtonProps = {
  content: string;
  onContentChange: (e: ChangeEvent<HTMLInputElement>) => void;
};

export const URLButton = ({ content, onContentChange }: URLButtonProps) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Box>
      <SuperButton
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "170px !important",
        }}
        onClick={() => setIsOpen(true)}
        isShownPingIcon={!isEmpty(content)}
      >
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="space-between"
          height="100%"
        >
          <Box display="flex" alignItems="center" gap={2}>
            <SVGInternalIcon
              icon="urlIcon"
              sx={{
                width: 32,
                height: 32,
              }}
            />
            <Typography
              sx={{
                fontWeight: "500",
                fontSize: "20px",
                lineHeight: "26px",
              }}
            >
              {t("docs.url")}
            </Typography>
          </Box>
          <Typography
            sx={{
              textAlign: "left",
              fontWeight: "500",
              fontSize: "16px",
              lineHeight: "26px",
            }}
          >
            {t("docs.inputYourUrl")}
          </Typography>
        </Box>
      </SuperButton>
      <SuperDialog
        title={t("docs.urlDialogTitle")}
        open={isOpen}
        onClose={() => setIsOpen(false)}
        sx={{
          "& .MuiDialog-paper": {
            width: "52rem",
          },
        }}
        actionControls={{
          primary: {
            label: t("common.ok"),
            onClick: () => {
              setIsOpen(false);
            },
          },
          secondary: {
            label: t("common.clear"),
            onClick: () => {
              onContentChange({
                target: { value: "" },
              } as ChangeEvent<HTMLInputElement>);
            },
          },
        }}
      >
        <TextField
          sx={{
            width: "100%",
            fieldset: {
              borderWidth: "1px !important",
            },
          }}
          value={content}
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            onContentChange(e);
          }}
          placeholder={t("docs.urlPlaceholder")}
        />
      </SuperDialog>
    </Box>
  );
};
